import { useState } from "react";
import { Row, Col, Typography } from "antd";
import { BTN_TXT, GLOBAL_CONSTANTS } from "../../constants/constants";
import { parseReferenceLinks } from "../../helpers/referenceLinks";
import "./Details.scss";

const { Text } = Typography;
const DESCRIPTION_TRUNCATE_LENGTH = 100;

const formatLinkHref = (url) => {
  if (!url) return url;
  const trimmed = url.trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

const ExpandableDescription = ({ text }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isTruncatable = text.length > DESCRIPTION_TRUNCATE_LENGTH;
  const displayText =
    !isTruncatable || expanded
      ? text
      : `${text.slice(0, DESCRIPTION_TRUNCATE_LENGTH)}...`;

  return (
    <div className="reference-link-description">
      <Text style={{ color: "#101924", fontSize: 14, fontWeight: 500 }}>
        {displayText}
      </Text>
      {isTruncatable ? (
        <button
          type="button"
          className="read-more-toggle"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? BTN_TXT.READ_LESS : BTN_TXT.READ_MORE}
        </button>
      ) : null}
    </div>
  );
};

const ReferenceLinksProfileView = ({ referenceLinks }) => {
  const links = parseReferenceLinks(referenceLinks).filter((entry) =>
    entry?.url?.trim(),
  );

  return (
    <Row
      gutter={[16, 16]}
      className="custom-profile-row reference-links-profile"
      align="top"
      style={{ marginBottom: 20 }}
    >
      <Col xs={24} lg={6}>
        <Text style={{ color: "#40566D", fontSize: 14, fontWeight: 500 }}>
          {GLOBAL_CONSTANTS.ADDITIONAL_REF_LINKS}
        </Text>
      </Col>

      <Col xs={24} lg={12}>
        {links.length === 0 ? (
          <Text style={{ color: "#101924", fontSize: 14, fontWeight: 500 }}>
            {GLOBAL_CONSTANTS.NA}
          </Text>
        ) : (
          <div className="reference-links-list">
            {links.map((entry, index) => (
              <div key={`${entry.url}-${index}`} className="reference-link-item">
                <div className="reference-link-field">
                  <Text className="reference-link-field-label">
                    {GLOBAL_CONSTANTS.REF_LINK}
                  </Text>
                  <a
                    href={formatLinkHref(entry.url)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="reference-link-url"
                  >
                    {entry.url}
                  </a>
                </div>
                {entry.description ? (
                  <div className="reference-link-field">
                    <Text className="reference-link-field-label">
                      {GLOBAL_CONSTANTS.LINK_DESC}
                    </Text>
                    <ExpandableDescription text={entry.description} />
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        )}
      </Col>

      <Col xs={24} lg={6} />
    </Row>
  );
};

export default ReferenceLinksProfileView;
